// extracted by mini-css-extract-plugin
export default {"dailyScoopTitleWrapper":"dailyScoop_dailyScoopTitleWrapper__fUJeb","dailyScoopTitle":"dailyScoop_dailyScoopTitle__sWjEs"};